export const VALID_REPORT_TYPES = ['BANK_VALIDATION', 'ACCOUNT'];
